module.exports = __webpack_public_path__ + "static/media/m-explorer.c788e984.png";